import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Chart } from 'angular-highcharts';
import { PointOptionsObject } from 'highcharts';
import { RejectedLoadsByUser } from '../../../../types';

@Component({
  selector: 'lohi-loads-declined',
  templateUrl: './loads-declined.component.html',
  styles: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoadsDeclinedComponent implements OnInit {
  @Input() private loads: RejectedLoadsByUser[];
  @Input() private days: number;
  private sortedLoads: RejectedLoadsByUser[];

  public labels: Array<string>;
  public chart: Chart;

  constructor(private router: Router) {}

  public ngOnInit(): void {
    this.sortedLoads = this.loads
      .slice()
      .filter((value) => value.percentRejected !== 0)
      .sort((a, b) => b.percentRejected - a.percentRejected);
    this.labels = this.sortedLoads.map((value) => value.userName);
    this.chart = new Chart({
      chart: {
        type: 'column',
      },
      title: {
        align: 'left',
        useHTML: true,
        text: `<div class="text-lg font-bold">Loads Declined <span class="text-blue-500">${this.days}d</span></div>`,
      },
      credits: {
        enabled: false,
      },
      yAxis: [
        {
          title: null,
          max: 100,
        },
      ],
      plotOptions: {
        series: {
          events: {
            click: (event) => {
              if (!event.point.options.custom.userId) {
                return;
              }
              this.router.navigate(['drivers', event.point.options.custom.userId]);
            },
          },
        },
      },
      xAxis: {
        type: 'category',
        categories: this.labels,
        visible: true,
      },
      series: [],
      tooltip: {
        formatter() {
          return (
            `<span class="font-bold" style="color: ${this.point.color}">` + this.series.name + '</span> ' + this.y + '%'
          );
        },
      },
    });
    const missedShifts: Array<[string, number] | PointOptionsObject> = [];
    for (const entry of this.sortedLoads) {
      missedShifts.push({
        label: entry.userName,
        custom: {
          userId: entry.userId,
        },
        y: entry.percentRejected,
      });
    }
    this.chart.addSeries(
      {
        name: 'Loads Declined',
        type: 'column',
        color: '#EF6048',
        data: missedShifts,
      },
      true,
      true,
    );
  }
}
